<template>
  <v-app id="admin-portal">
  
    <v-content>
      <v-container fluid
        class="fill-height content-top">
          <slot name="content"></slot>
      </v-container>
    <v-footer
      app
      :color="footerColor"
      class="white--text">
       T-Systems México
      <v-spacer />
      <span>v{{ appVersion }}</span>
    </v-footer>
    </v-content>

  </v-app>
</template>

<script>
import i18nMessages from './i18n/anonymous.messages'
import { mapGetters } from "vuex";

var self = null
export default {
  created () {
    self = this
    this.$i18n.locale = this.locale
  },
  beforeDestroy () {
  },
  i18n: i18nMessages,
  data () {
    return {
      footerColor: "primary"
    }
  },
  computed: {

    ...mapGetters(["isLoading", "locale", "isSignedIn"]),
    hasToken() {
      return this.isSignedIn
    },
    appVersion () {
      return process.env.VUE_APP_VERSION || "0.0.0"
    }
  },
  watch: {
     hasToken: (value) => {
      //** console.log("hasToken:" + value)
      if (value) {
        self.$store.dispatch("stopLoader")
        self.$router.push("/");
      }
    },
    locale (value) {
      self.$i18n.locale = value
    },
    isLoading (value) {
      self.footerColor = value ? "black" : "primary"
    }

  }
}
</script>
